import { SFNodeType } from '@sciflow/schema';
import { Node } from 'prosemirror-model';

export const getPartType = (node: Node): string | undefined => {
  const nodeType = typeof node?.attrs?.type === 'string' ? node.attrs.type : undefined;
  if (nodeType === 'bibliography') {
    return nodeType;
  }

  const firstChild = node.firstChild;
  if (firstChild?.type?.name === SFNodeType.heading && firstChild?.attrs?.level === 1) {
    const headingType =
      typeof firstChild.attrs?.type === 'string' ? firstChild.attrs.type : undefined;
    if (headingType) {
      return headingType;
    }
  }

  return nodeType;
};
